// extracted by mini-css-extract-plugin
module.exports = {"pictureTextContainer":"PictureTextLeft_pictureTextContainer__350Ml","imageWrapper":"PictureTextLeft_imageWrapper__1GAqP","textContainer":"PictureTextLeft_textContainer__2fOfn"};